<template>
    <div :class="'menu_page' + (isCollapse ? ' collapase' : '')">
        <div class="menu_logo" style="margin-top: 9px;">
            <img v-if="!isCollapse" style="height: 38px;margin: 0 30px;" src="../assets/img/logo_reverse.svg">
            <img v-else style="height: 38px;margin: 0 13px;" src="../assets/img/logo_plain.svg">
        </div>
        <div class="collapse-btn" @mouseleave.stop="noop">
            <el-button type="text" v-if="!isCollapse" @click="changeCollapse" class="nav-collapse__bar">
                <v-svg-icon class="icon-nav__spread" name="icon-zhankai" />
            </el-button>
            <el-button type="text" v-else @click="changeCollapse" class="nav-collapse__bar">
                <v-svg-icon class="icon-nav__spread" name="icon-guanbi" />
            </el-button>
        </div>
        <div class="main-nav">
            <el-menu
                ref="mainNav"
                mode="vertical"
                background-color="#333333"
                text-color="#fbfbfb"
                active-text-color="#4b74ff"
                :default-active="activeIndex"
                active-background-color="#4b74ff"
                :unique-opened="true"
                :router="true"
                @mouseenter.native="activeMenu"
                :collapse="isCollapse"
                :collapse-transition="false"
                class="menu-left__bar">
                <el-menu-item index="/index/home">
                    <i class="iconfont icon-gongzuotai"></i>
                    <span slot="title">工作台</span>
                </el-menu-item>
                <el-submenu index="2">
                    <template slot="title">
                        <i class="iconfont icon-gailan"></i>
                        <span>计算个税</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/tax/calculator">个税计算器</el-menu-item>
                        <el-menu-item index="/index/tax/batch">结算试算</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3" v-if="[1,2].includes(userInfo.role_id)">
                    <template slot="title">
                        <i class="iconfont icon-xiangmuguanli"></i>
                        <span>项目管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/project/add">新增项目</el-menu-item>
                        <el-menu-item index="/index/project">项目列表</el-menu-item>
                        <el-menu-item index="/index/project/services">服务列表</el-menu-item>
                        <el-menu-item index="/index/project/prepend">待处理列表</el-menu-item>
                        <el-menu-item index="/index/project/serviceresults">服务成果</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4" v-if="[1,2].includes(userInfo.role_id)">
                    <template slot="title">
                        <i class="iconfont icon-chengyuanguanli"></i>
                        <span>服务人员</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/member">人员列表</el-menu-item>
                        <!-- <el-menu-item index="/index/member/import">导入成员</el-menu-item> -->
                        <!--                        <el-menu-item index="/index/member/applies">申请列表</el-menu-item>-->
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="5" v-if="[1,3].includes(userInfo.role_id)">
                    <template slot="title">
                        <i class="iconfont icon-piliangfukuan"></i>
                        <span>结算管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/pay/record">结算列表</el-menu-item>
                        <el-menu-item index="/index/pay/prepaid">待支付项目</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6" v-if="[1,3].includes(userInfo.role_id)">
                    <template slot="title">
                        <i class="iconfont icon-yinhang"></i>
                        <span>财务管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/finance/capital">资金管理</el-menu-item>
                        <!-- <el-menu-item index="/index/finance/taxagent">代缴查询</el-menu-item> -->
                        <el-menu-item index="/index/finance/fee">财务明细</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="7">
                    <template slot="title">
                        <i class="iconfont icon-jibenziliao"></i>
                        <span>账户设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/index/info">基本信息</el-menu-item>
                        <el-menu-item index="/index/info/safe">安全中心</el-menu-item>
                        <el-menu-item index="/index/info/services" v-if="[1].includes(userInfo.role_id)">服务需求
                        </el-menu-item>
                        <el-menu-item index="/index/info/prosetting" v-if="[1].includes(userInfo.role_id)">项目设置
                        </el-menu-item>
                        <el-menu-item index="/index/info/members" v-if="[1].includes(userInfo.role_id)">成员列表
                        </el-menu-item>
                        <el-menu-item index="/index/info/roles" v-if="[1].includes(userInfo.role_id)">权限管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>
<script>
export default {
    name: 'leftmenu',
    data () {
        return {
            userInfo: {},
            activeIndex: '',
            openedMenu: []
        }
    },
    mounted () {
        this.getUserInfo()
        let arr = this.$route.path.split('/')
        if (arr[3]) {
            this.activeIndex = '/' + arr[1] + '/' + arr[2] + '/' + arr[3]
        } else {
            this.activeIndex = '/' + arr[1] + '/' + arr[2]
        }
    },
    computed: {
        isCollapse () {
            return this.$store.state.isCollapse
        }
    },
    watch: {
        '$route': 'indexWatch'
    },
    methods: {
        activeMenu () {
            if (this.isCollapse) {
                this.$store.dispatch('changeCollapseStatus', true)
                this.$el.addEventListener('mouseleave', this.mouseleave)
            }
        },
        noop () {
        },
        mouseleave () {
            this.$store.dispatch('changeCollapseStatus', false)
        },
        changeCollapse () {
            let status = !this.isCollapse
            this.$el.removeEventListener('mouseleave', this.mouseleave)
            this.$store.dispatch('changeCollapseStatus', status)
        },
        indexWatch () {
            let arr = this.$route.path.split('/')
            if (arr[3]) {
                this.activeIndex = '/' + arr[1] + '/' + arr[2] + '/' + arr[3]
            } else {
                this.activeIndex = '/' + arr[1] + '/' + arr[2]
            }
        },
        getUserInfo () {
            try {
                if (window.localStorage.getItem('USERINFO')) {
                    this.userInfo = JSON.parse(window.localStorage.getItem('USERINFO'))
                } else {
                    throw new Error('获取本地userInfo失败')
                }
            } catch (err) {
                this.$http.get('/api/user/userinfo')
                    .then(res => {
                        if (res.code === 0) {
                            this.userInfo = res.data
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
        }
    }
}
</script>
<style lang="scss">
    @import "../assets/style/var";
    @import '../assets/style/index.scss';

    .el-menu-item.is-active {
        background-color: $--color-primary !important;
        color: #fff !important;

        .iconfont {
            color: #fff !important;
        }
    }

    .icon-nav__spread {
        font-size: 16px;
        font-weight: 100;
    }

    .collapase .el-menu-item, .collapase .el-submenu__title {
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-align: center;

        .el-tooltip {
            padding-left: 0 !important;
            padding-right: 0 !important;
            text-align: center;
        }
    }

    .el-menu--vertical {
        .el-menu-item-group__title {
            display: none;
        }

        .el-menu--popup {
            max-width: 120px;

            .el-menu-item {
                height: 40px;
                line-height: 40px;
            }
        }
    }

    .el-submenu__title,
    .el-submenu,
    .el-menu-item {
        &:hover {
            background-color: #404040 !important;
        }
    }

    .el-menu-item.is-active {
        &:hover {
            background-color: #246efc !important;
        }
    }

    .el-submenu.is-opened {
        background-color: red;

        .el-submenu__title {
            background-color: #292929 !important;
        }

        .el-menu-item {
            background-color: #292929 !important;

            &:hover {
                background-color: #404040 !important;
            }

            &.is-active {
                background-color: #246efc !important;

                &:hover {
                    background-color: #246efc !important;
                }
            }
        }
    }

    .collapase {
        .el-submenu {
            &.is-active {
                .el-submenu__title {
                    background-color: #292929 !important;

                    &:hover {
                        background-color: #404040 !important;
                    }
                }
            }
        }
    }

</style>
